import type { IUser } from "@bbj-types/user";
import type { ObjectId } from "@bbj-types/utils";

export enum NotificationTypes {
  CER_VALIDATION = "cer_validation",
  EPT_RENEWAL_VALIDATION = "ept_renewal_validation",
  EPT_REORIENTATION_VALIDATION = "ept_reorientation_validation",
  BENEFICIARY_SOCIAL_APPLY = "beneficiary_social_apply",
  PRESCRIPTION_FILLED = "prescription_filled",
  BENEFICIARY_OFFER_PROPOSED = "beneficiary_offer_proposed",
  CANDIDATE_OUT = "candidate_out",
  SANCTION_VALIDATION = "sanction_validation",
}

interface INotificationBase {
  _id: ObjectId;
  type: NotificationTypes;
  users: Pick<IUser, "_id" | "firstName" | "lastName">[];
  organisation: ObjectId;
  seen: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface INotificationCenterCard {
  externalId?: string;
  candidateId?: string;
  title: string;
  subtitle: string;
}

type NotificationReturnTypes = {
  [NotificationTypes.CER_VALIDATION]: string;
  [NotificationTypes.EPT_RENEWAL_VALIDATION]: string;
  [NotificationTypes.EPT_REORIENTATION_VALIDATION]: string;
  [NotificationTypes.BENEFICIARY_SOCIAL_APPLY]: INotificationCenterCard;
  [NotificationTypes.PRESCRIPTION_FILLED]: INotificationCenterCard;
  [NotificationTypes.BENEFICIARY_OFFER_PROPOSED]: string;
  [NotificationTypes.CANDIDATE_OUT]: INotificationCenterCard;
  [NotificationTypes.SANCTION_VALIDATION]: string;
};

export type INotification<T extends NotificationTypes = NotificationTypes> = INotificationBase & {
  type: T;
  data: NotificationReturnTypes[T];
};

export const isBeneficiarySocialApplyNotification = (
  n: INotification
): n is INotification<NotificationTypes.BENEFICIARY_SOCIAL_APPLY> => {
  return (
    (n as INotification<NotificationTypes.BENEFICIARY_SOCIAL_APPLY>).type === NotificationTypes.BENEFICIARY_SOCIAL_APPLY
  );
};

export const isPrescriptionFilledNotification = (
  n: INotification
): n is INotification<NotificationTypes.PRESCRIPTION_FILLED> => {
  return (n as INotification<NotificationTypes.PRESCRIPTION_FILLED>).type === NotificationTypes.PRESCRIPTION_FILLED;
};

export const isCandidateOutNotification = (n: INotification): n is INotification<NotificationTypes.CANDIDATE_OUT> => {
  return (n as INotification<NotificationTypes.CANDIDATE_OUT>).type === NotificationTypes.CANDIDATE_OUT;
};
